import AncillaryUIModel from './ancillary';

class TicketedTravelerAncillaryUIModel {
  constructor({
    ancillary = {},
    emd = undefined,
    legCode = null,
    quantity = 0,
    segmentCode = null,
  } = {}) {
    this.ancillary = new AncillaryUIModel(ancillary);
    this.emd = emd;
    this.legCode = legCode;
    this.quantity = quantity;
    this.isPaid = true;
    if (this.ancillary && this.ancillary.type === 'UPG') {
      this.segmentCode = segmentCode;
    }
  }

  getTotal() {
    return this.ancillary.getTotal();
  }

  getTotalPoints() {
    return this.ancillary.getTotalPoints();
  }

  getTaxDetails() {
    return this.ancillary.getTaxDetails();
  }

  getType() {
    return this.ancillary.type === '029' ? 'CBX' : this.ancillary.type;
  }

  getGroupCode() {
    return this.ancillary.groupCode;
  }

  toApi() {
    return {
      '_meta':{
        'class':'TicketedTravelerAncillary',
      },
      'ancillary': this.ancillary.toApi(),
      'emd': this.emd,
      'legCode': this.legCode,
      'quantity': this.quantity,
    };
  }
}

export default TicketedTravelerAncillaryUIModel;
